// components/StatCard.jsx

import React from "react";
import {
  Paper,
  Typography,
  Stack,
  Box,
} from "@mui/material";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { useNavigate } from "react-router-dom";

const StatCard = ({
  title,
  value,
  subtitle,
  icon,
  color,
  route,
}) => {
  const navigate = useNavigate();

  return (
    <Paper
      elevation={0}
      onClick={() => navigate(route)}
      sx={{
        p: 2.5,
        borderRadius: 4,
        cursor: "pointer",
        border: "1px solid #ECECEC",
        transition: ".25s",

        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 10px 25px rgba(0,0,0,.08)",
        },
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box
          sx={{
            width: 52,
            height: 52,
            borderRadius: "50%",
            bgcolor: `${color}15`,
            color,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {icon}
        </Box>

        <ChevronRightRoundedIcon color="action" />
      </Stack>

      <Typography
        mt={2}
        variant="body2"
        color="text.secondary"
      >
        {title}
      </Typography>

      <Typography
        variant="h5"
        fontWeight={700}
        mt={0.5}
      >
        {value}
      </Typography>

      {subtitle && (
        <Typography
          variant="caption"
          color="text.secondary"
        >
          {subtitle}
        </Typography>
      )}
    </Paper>
  );
};

export default StatCard;